import { FALLBACK_DOMAIN } from '@hub/libs/constants';
import { getDomainForLocale } from '@icommerce/i18n';
import type { Material } from '@igus/iglidur-free-form-hub-interfaces';
import type { MaterialAdditionalInformation } from '@igus/injection-molding-domain';
import { materialsAdditionalInformation } from '@igus/injection-molding-domain';

export const getMaterialDataUrl = (material: Material, locale: string, language: string): string => {
  const country = locale.includes('-') ? locale.split('-')[1] : locale.toUpperCase();
  const domain = getDomainForLocale(locale) || FALLBACK_DOMAIN;
  const materialData = materialsAdditionalInformation[material.name] as MaterialAdditionalInformation[];

  const ensureAbsoluteUrl = (url: string): string => (/^https?:\/\//.test(url) ? url : `https://${url}`);

  if (materialData && materialData.length > 0) {
    const materialInfo = materialData.find(item => item.country === country && item.language === language);

    if (materialInfo) {
      return ensureAbsoluteUrl(materialInfo.url);
    }

    const fallBackMaterialInfo = materialData.find(item => item.country === 'DE');
    if (fallBackMaterialInfo) {
      return ensureAbsoluteUrl(fallBackMaterialInfo.url);
    }
  }

  if (material.catalogProductId) {
    const productUrl = `${domain}/product/${material.catalogProductId}`;
    return ensureAbsoluteUrl(productUrl);
  }

  return '';
};
